<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import facebook from "@core/assets/icons/facebook.svg?raw";
	import instagram from "@core/assets/icons/instagram.svg?raw";
	import tiktok from "@core/assets/icons/tiktok.svg?raw";

	const socials = [
		{
			href: "https://www.tiktok.com/@zazehnuto.cz",
			label: "TikTok",
			icon: tiktok,
		},
		{
			href: "https://www.instagram.com/zazehnuto.cz",
			label: "Instagram",
			icon: instagram,
		},
		{
			href: "https://www.facebook.com/profile.php?id=61578575624373",
			label: "Facebook",
			icon: facebook,
		},
	];
</script>

<section class="bg-nov-light-100 border-b border-nov-light-200">
	<div class="flex flex-wrap justify-center items-center gap-x-39 gap-y-5">
		<span class="h3 shrink-0 !text-nov-red-300">Sledujte nás na sociálních sítích</span>
		<div class="flex gap-4 items-center">
			{#each socials as social (social.href)}
				<a
					href={social.href}
					target="_blank"
					rel="noopener noreferrer"
					class="shrink-0 rounded-full bg-white p-4 justify-center flex items-center"
					aria-label={social.label}
				>
					<Icon icon={social.icon} class={["text-nov-red-300 size-8 sm:size-10"]} square />
				</a>
			{/each}
		</div>
	</div>
</section>
